import MarkReadButton from 'gcs-common/components/feature-mark-read/mark-read-button';
import { Button, ButtonVariant } from 'gcs-common/design-system/ui/button';
import { cn } from 'gcs-common/design-system/utils/tailwind-merge';
import { CHANNEL_TYPE } from 'gcs-common/helper/channelTypeHelper';
import { getChannelType } from 'gcs-common/slices/channel/channelSelectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getCurrentUserId, getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getCurrentUserIsMemberOfChannel } from 'gcs-common/slices/salesSpaceChannels/salesSpaceChannelsSelectors';
import joinSalesSpace from 'gcs-common/slices/salesSpaceChannels/salesSpaceChannelsThunks/joinSalesSpace';
import { useDispatch, useSelector } from 'react-redux';

type Props = {
  className?: string;
  innerClassName?: string;
};

function SalesSpaceJoinOverlay({ className }: Props) {
  const dispatch = useDispatch();
  const channelId = useSelector(getSelectedChannelId) as string | undefined;
  const isAgent = useSelector(getIsAgent);
  const isJoined = useSelector(getCurrentUserIsMemberOfChannel(channelId));
  const channelType = useSelector(getChannelType(channelId));
  const currentUserId = useSelector(getCurrentUserId);

  const shouldShow = Boolean(isAgent && !isJoined && channelType === CHANNEL_TYPE.SALES_SPACE && channelId);
  if (!shouldShow) return null;

  return (
    <div className={cn('box-border flex w-full items-center justify-center gap-4 bg-white p-4 shadow-2xl', className)}>
      <MarkReadButton showDisabledState={true} />
      <Button
        variant={ButtonVariant.solid_accent}
        // @ts-expect-error use ts at some point
        onClick={() => channelId && dispatch(joinSalesSpace({ channelId, currentUserId }))}
      >
        Chat beitreten
      </Button>
    </div>
  );
}

export default SalesSpaceJoinOverlay;
